import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouterService {

  public activeRoute = new Subject<string>();

  constructor() { }

  public setRoute(route: string){
    if(route === '/instructions'){
      this.activeRoute.next('Instructions');
    } else if(route === '/policy'){
      this.activeRoute.next('Policy');
    }
  }

  public getActiveRoute(): Observable<string> {
    return this.activeRoute.asObservable();
  }
}
